module.exports = __webpack_public_path__ + "static/sstep2-ed1610b352b9267dc82eed8033ebed00.png";